export const formatDescription = htmlString => {
  if (!htmlString) return null

  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')
  const paragraphs = doc.querySelectorAll('p')

  let unparsableLinesWithText = 0
  const specs = Array.from(paragraphs)
    .flatMap(p => {
      const lines = p.innerHTML.split(/<br\s*\/?>/i)
      return lines.map(line => {
        const tempEl = document.createElement('div')
        tempEl.innerHTML = line
        const text = (tempEl.textContent || tempEl.innerText).trim()

        if (!text || text === '&nbsp;') return null

        if (text.includes(':')) {
          const parts = text.split(':')
          const label = parts[0].trim()
          const value = parts.slice(1).join(':').trim()
          if (label && value) {
            return { label, value }
          }
        }

        unparsableLinesWithText++
        return null
      })
    })
    .filter(Boolean)

  if (unparsableLinesWithText > 0 || specs.length === 0) {
    return null
  }

  return specs
}
